import type { ComponentType } from "react";
import type { Family } from "../../shared/model";
import type { BoardProps } from "./types";
import CutBoard from "./cut/CutBoard";
import StarsBoard from "./stars/StarsBoard";
import CoinsBoard from "./coins/CoinsBoard";

export const BOARDS: Record<Family, ComponentType<BoardProps>> = { cut: CutBoard, stars: StarsBoard, coin: CoinsBoard };
